interface IconProps {
  className?: string;
}

const TextColorPickerIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 24"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M3.645 20a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2h-16a1 1 0 0 1-1-1M16.14 14H9.15L7.8 17.371a1 1 0 1 1-1.857-.742l5.45-13A1 1 0 0 1 12.322 3h.646a1 1 0 0 1 .928.629l5.45 13a1 1 0 0 1-1.857.742zm-.8-2-2.695-6.115L9.949 12z"
      ></path>
    </svg>
  );
};

export default TextColorPickerIcon;
